module.exports = __webpack_public_path__ + "static/img/7.6334da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/7.png
// module id = NAL8
// module chunks = 5